import { render, staticRenderFns } from "./sample-select-boxes.vue?vue&type=template&id=731791a9&"
import script from "./sample-select-boxes.vue?vue&type=script&lang=js&"
export * from "./sample-select-boxes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports